/* -----------------------------------------------------------------------------
| Copyright (c) Jupyter Development Team.
| Distributed under the terms of the Modified BSD License.
|----------------------------------------------------------------------------*/
import { Token } from '@lumino/coreutils';
/**
 * The tree path updater token.
 */
export const ITreePathUpdater = new Token('@jupyterlab/application:ITreePathUpdater');
//# sourceMappingURL=treepathupdater.js.map